<template>
  <div class="role-page full-height">
      <table-con>
        <div slot="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
             <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>购买账号配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div slot="search">
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title" style="width:110px">账户ID:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.accountNumber"
                size = "small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row" >
            <div class="query-title" style="text-align:right">平台:</div>
            <div class="flex1" >
              <el-select v-model="queryInfo.platformType" placeholder="请选择" size="small" clearable>
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="13" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right" >
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="insert">新增</el-button>
            </div>
          </el-col>
        </el-row>
        </div>
        <div slot="table" class="full-height display-col">
           <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="recordList"
            border
            height="550"
           >
           <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
             <el-table-column
              prop="platformType"
              :index="indexMethod"  sortable
              align="center"
              label="平台">
              <template v-slot="scope">
              {{typeShow(scope.row.platformType)}}
            </template>
            </el-table-column>
            <el-table-column prop="accountNumber" label="账号ID"></el-table-column>
             <el-table-column
             prop="accountPassword"
             align="center"
              label="登录密码">
            </el-table-column>
            <el-table-column
              prop="status"
              :index="indexMethod"  sortable
              align="center"
              label="启用状态">
              <template v-slot="scope">
              {{statusShow(scope.row.status)}}
            </template>
            </el-table-column>
             <el-table-column
              prop="note"
              label="备注">
            </el-table-column>
             <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                class="list-btn btn-blue"
                @click="update(scope.row)">
                编辑
                </el-button>
              </div>
              <div class="btn-row"  @click="infodelete(scope.row)">
                <el-button
                class="list-btn btn-blue">
                删除
                </el-button>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        </div>
      </table-con>
       <!-- 修改 -->
        <el-dialog
      :title="dialogTitle"
      v-loading="isLoading"
      :visible.sync="updateDialogVisible"
      width="30%"
      @close="updateDialogClose"
    >
        <el-form :model="companyInfo" :rules="rules" ref="companyInfo" label-width="110px" class="demo-companyInfo">
            <el-form-item label="平台" prop="platformType">
                <el-select v-model="companyInfo.platformType" placeholder="请选择平台">
                  <el-option v-for="(item,index) in platformTypeOptions"
                             :key="index" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="登录ID" prop="accountNumber">
            <el-input v-model="companyInfo.accountNumber"></el-input>
            </el-form-item>
             <el-form-item label="登录密码" prop="accountPassword">
            <el-input v-model="companyInfo.accountPassword"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
            <el-input v-model="companyInfo.note"></el-input>
            </el-form-item>
            <el-form-item label="启用状态" prop="status">
            <el-switch
                 v-model="companyInfo.status"
                 active-text="启用"
                 active-value="0"
                 inactive-text=""
                 inactive-color="#909399"
                 inactive-value="1">
            </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="form-btn btn-gray" @click="clearForm">取 消</el-button>
          <el-button class="form-btn btn-blue" @click="updateSave('companyInfo')">提 交</el-button>

        </div>
        </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
export default {
  name: 'configAccountNumber',
  components: { tableCon },
  data() {
    return {
      platformTypeOptions: [{
        name: '淘宝',
        value: '0'
      }, {
        name: '1688',
        value: '1'
      }, {
        name: '京东',
        value: '2'
      }, {
        name: '拼多多',
        value: '3'
      }],
      companyInfo: {
          id:'',
          platformType:'',
          accountNumber:'',
          accountPassword:'',
          status:'',
          note:''
        },
      queryInfo:{
        platformType:'',
        accountNumber:'',
        pageSize:10,
        pageNum:1
      },
      recordList:[],
      total:0,
      isLoading:false,
      dialogTitle:'',
      statusOptions:[
        {
          value: '0',
          label: '淘宝'
        }, {
          value: '1',
          label: '1688'
        }, {
          value: '2',
          label: '京东'
        }, {
          value: '3',
          label: '拼多多'
        }
      ],
      rules:{
        platformType:[
            {required:true,message:'请选择平台',trigger:'blur'}
        ],
        accountNumber:[
            {required:true,message:'请输入账号',trigger:'blur'}
        ],
        accountPassword:[
            {required:true,message:'请输入密码',trigger:'blur'}
        ],
      },
      updateDialogVisible:false,
    }
  },
  methods:{
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    updateSave(formName){    //保存按钮
        var my = this;
      //保存按钮
      this.$refs.companyInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "cms/configAccountNumber/insertAndEdit";
          const { data: res } = await my.$http.post(url, my.companyInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getrecordList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    clearForm() {   //弹窗的取消按钮
      this.initForm();
      this.updateDialogVisible=false;
      },
    initForm(){   //初始化弹窗的内容
      this.companyInfo = {
          id:'',
          platformType:'',
          accountNumber:'',
          accountPassword:'',
          status:'',
          note:''
      };
    },
    searchList(){    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    infodelete(row) {
      this.$confirm("确定要删除本账号吗？",  {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const {data: res} = await this.$http.post(`cms/configAccountNumber/insertAndEdit`, {
            id: row.id,
            delFlag: 1
        });
        if (res.code !== 200) {
          this.$message.error(res.message);
          await this.getrecordList();
        } else {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          await this.getrecordList();
        }
        await this.getrecordList();
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    async getrecordList(){
      this.isLoading = true
      const {data:res} = await this.$http.get('cms/configAccountNumber/list',{params:this.queryInfo});
      this.isLoading = false
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear(){    //清空
      this.queryInfo = {
        platformType:'',
        accountNumber:'',
        pageSize:10,
        pageNum:1
      }
    },
     statusShow(status){
      switch(status){
        case '1':
        return '禁用'
        break;
        case '0':
        return '启用'
        break;

      }
    },
    typeShow(status){
      switch(status){
        case '0':
        return '淘宝'
        break;
        case '1':
        return '1688'
        break;
        case '2':
        return '京东'
        break;
        case '3':
        return '拼多多'
        break;
      }
    },
    update(row){     //编辑
      this.dialogTitle='编辑';
      this.updateDialogVisible = true;
      this.getrecordList;
      this.companyInfo = {
         id:row.id,
         platformType:row.platformType,
          accountNumber:row.accountNumber,
          accountPassword:row.accountPassword,
          status:row.status,
          note:row.note
      };
    },
    insert(row){     //新增
     this.dialogTitle='新增';
     this.updateDialogVisible = true;
     this.getrecordList;
     this.companyInfo = {
          id:'',
          platformType:'',
          accountNumber:'',
          accountPassword:'',
          status:'0',
          note:''
      };
    },
    updateDialogClose(){    //关闭弹窗
      console.log('close');
      this.updateDialogVisible = false;
    },
  },
  created() {
    this.getrecordList();
  }
};
</script>

<style lang="less" scoped>
  .role-page > .search-container{
    height: 60px !important;
  }
  .el-table .el-button--small{
    padding: 4px 10px;
  }
</style>
